export default __webpack_public_path__ + "static/media/289.81c45ac5.gif";